import { CSSProperties } from "react";

import style from "./index.module.css";

export const PaperClipIcon = (styles?: CSSProperties) => <div className={style.warning} style={styles}></div>;
